import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PrivacyPolicyComponent } from './privacy-policy.component';

const routes: Routes = [
    {
        path: 'home',
        component: PrivacyPolicyComponent,
    }
];

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild(routes),
    ],
    declarations: [
        PrivacyPolicyComponent
    ],
    exports: [
        PrivacyPolicyComponent
    ]
})
export class PrivacyPolicyModule { }
